import { Config } from '../app.configs';
import { ModelInterface } from './model.interface';

export class Account implements ModelInterface {
    id: number;
    name: string;
    timezone: string;
    country: string;
    verified: boolean;
    reference: string;
    created_at: string;
    updated_at: string;

    /**
     * Class constructor
     * @param  {any = null} attrs
     */
    constructor(attrs: any = null) {
        if (attrs) {
            this.build(attrs);
        }
    }

    get is_acceptable() {
        return !Config.in_mode('live') || this.verified;
    }

    /**
     * Build the object attributes
     * @param {any} attrs
     */
    build(attrs: any): void {
        this.id = attrs.id;
        this.name = attrs.name;
        this.timezone = attrs.timezone;
        this.country = attrs.country;
        this.verified = attrs.verified;
        this.reference = attrs.reference;
        this.created_at = attrs.created_at;
        this.updated_at = attrs.updated_at;
    }

    /**
     * Return a JSON object representation of the object
     * @return {Object}
     */
    toJson(): Object {
        return {
            id: this.id,
            name: this.name,
            timezone: this.timezone,
            country: this.country
        };
    }
}
